export default "__VITE_ASSET__D_EAb7M$__"